import { StringParam, useQueryParam } from 'use-query-params'
import { useEffect, useState } from 'react'
import Context from '../models/Context'

const testContext = {
  account: {
    id: 1275647520,
    domain: 'baraagency',
    owner: {
      name: 'Justin Benson',
      email: 'justin@baraagency.com',
    },
  },
  person: {
    id: 2,
    firstName: 'Melissa',
    lastName: 'Hartman',
  },
  user: {
    id: 1,
    name: 'John Doe',
    email: 'j.doe@example.com',
  },
}

export default function useFUBVerification() {
  const [context, _setContext] = useQueryParam('context', StringParam)
  //const [signature, _setSignature] = useQueryParam('signature', StringParam)

  const [contextObj, setContextObj] = useState<Context | undefined>(
    !(process.env.NODE_ENV === 'development') ? undefined : testContext
  )

  useEffect(() => {
    if (context) {
      const decodedContext = JSON.parse(atob(context))
      setContextObj(decodedContext)
    }
  }, [context])

  return contextObj
}
